import React from "react";

import {
  Box,
  Skeleton,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  useTheme,
  alpha,
} from "@mui/material";

const COLS = ["Name", "Alias", "Role", "Projects", "Status", ""];

const OrganizationListSkeleton = () => {
  const theme = useTheme();

  return (
    <Box sx={{ width: "100%" }}>
      <Typography
        component="h1"
        sx={{
          position: "absolute",
          width: 1,
          height: 1,
          p: 0,
          m: -1,
          overflow: "hidden",
          clip: "rect(0 0 0 0)",
          whiteSpace: "nowrap",
          border: 0,
        }}
      >
        Organizations
      </Typography>
      {/* Page header skeleton */}
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          marginBottom: "24px",
        }}
      >
        <Skeleton variant="text" width={180} height={28} />
        <Skeleton
          variant="rounded"
          width={170}
          height={34}
          sx={{ borderRadius: "8px" }}
        />
      </Box>

      {/* Table card container — matches the real table layout */}
      <Box
        sx={{
          backgroundColor: "background.paper",
          border: `1px solid ${alpha(theme.palette.divider, 0.08)}`,
          borderRadius: "12px",
          boxShadow: "0 1px 2px rgba(0, 0, 0, 0.04)",
          padding: "20px",
          overflow: "auto",
        }}
      >
        <TableContainer>
          <Table sx={{ width: "100%", borderCollapse: "collapse" }}>
            <TableHead>
              <TableRow>
                {COLS.map((col) => (
                  <TableCell
                    key={col}
                    sx={{
                      fontSize: "11px",
                      fontWeight: 700,
                      textTransform: "uppercase",
                      letterSpacing: "0.08em",
                      color: "text.secondary",
                      borderBottom: `1px solid ${alpha(theme.palette.divider, 0.08)}`,
                      padding: "10px 12px",
                      whiteSpace: "nowrap",
                    }}
                  >
                    {col}
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {Array.from({ length: 3 }).map((_, rowIdx) => (
                <TableRow key={rowIdx}>
                  <TableCell
                    sx={{
                      padding: "14px 12px",
                      borderBottom: `1px solid ${alpha(theme.palette.divider, 0.08)}`,
                    }}
                  >
                    <Skeleton
                      variant="rounded"
                      width={120}
                      height={12}
                      sx={{ borderRadius: 4 }}
                    />
                  </TableCell>
                  <TableCell
                    sx={{
                      padding: "14px 12px",
                      borderBottom: `1px solid ${alpha(theme.palette.divider, 0.08)}`,
                    }}
                  >
                    <Skeleton
                      variant="rounded"
                      width={60}
                      height={12}
                      sx={{ borderRadius: 4 }}
                    />
                  </TableCell>
                  <TableCell
                    sx={{
                      padding: "14px 12px",
                      borderBottom: `1px solid ${alpha(theme.palette.divider, 0.08)}`,
                    }}
                  >
                    <Skeleton
                      variant="rounded"
                      width={70}
                      height={22}
                      sx={{ borderRadius: "12px" }}
                    />
                  </TableCell>
                  <TableCell
                    sx={{
                      padding: "14px 12px",
                      borderBottom: `1px solid ${alpha(theme.palette.divider, 0.08)}`,
                    }}
                  >
                    <Skeleton
                      variant="rounded"
                      width={30}
                      height={12}
                      sx={{ borderRadius: 4 }}
                    />
                  </TableCell>
                  <TableCell
                    sx={{
                      padding: "14px 12px",
                      borderBottom: `1px solid ${alpha(theme.palette.divider, 0.08)}`,
                    }}
                  >
                    <Skeleton
                      variant="rounded"
                      width={70}
                      height={22}
                      sx={{ borderRadius: "12px" }}
                    />
                  </TableCell>
                  <TableCell
                    sx={{
                      padding: "14px 12px",
                      borderBottom: `1px solid ${alpha(theme.palette.divider, 0.08)}`,
                    }}
                  />
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </Box>
    </Box>
  );
};

export default OrganizationListSkeleton;
